import * as React from "react";

const LayoutIcon = (props) => (
  <svg
    height={20}
    width={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M4 6.1C4 5.53995 4 5.25992 4.10899 5.04601C4.20487 4.85785 4.35785 4.70487 4.54601 4.60899C4.75992 4.5 5.03995 4.5 5.6 4.5H8.4C8.96005 4.5 9.24008 4.5 9.45399 4.60899C9.64215 4.70487 9.79513 4.85785 9.89101 5.04601C10 5.25992 10 5.53995 10 6.1V8.9C10 9.46005 10 9.74008 9.89101 9.95399C9.79513 10.1422 9.64215 10.2951 9.45399 10.391C9.24008 10.5 8.96005 10.5 8.4 10.5H5.6C5.03995 10.5 4.75992 10.5 4.54601 10.391C4.35785 10.2951 4.20487 10.1422 4.10899 9.95399C4 9.74008 4 9.46005 4 8.9V6.1Z"
        stroke={props.stroke ? props.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
      <path
        d="M13 6C13 5.53406 13 5.30109 13.0761 5.11732C13.1776 4.87229 13.3723 4.67761 13.6173 4.57612C13.8011 4.5 14.0341 4.5 14.5 4.5H18.5C18.9659 4.5 19.1989 4.5 19.3827 4.57612C19.6277 4.67761 19.8224 4.87229 19.9239 5.11732C20 5.30109 20 5.53406 20 6C20 6.46594 20 6.69891 19.9239 6.88268C19.8224 7.12771 19.6277 7.32239 19.3827 7.42388C19.1989 7.5 18.9659 7.5 18.5 7.5H14.5C14.0341 7.5 13.8011 7.5 13.6173 7.42388C13.3723 7.32239 13.1776 7.12771 13.0761 6.88268C13 6.69891 13 6.46594 13 6Z"
        stroke={props.stroke ? props.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{" "}
      <path
        d="M13 12C13 11.5341 13 11.3011 13.0761 11.1173C13.1776 10.8723 13.3723 10.6776 13.6173 10.5761C13.8011 10.5 14.0341 10.5 14.5 10.5H18.5C18.9659 10.5 19.1989 10.5 19.3827 10.5761C19.6277 10.6776 19.8224 10.8723 19.9239 11.1173C20 11.3011 20 11.5341 20 12C20 12.4659 20 12.6989 19.9239 12.8827C19.8224 13.1277 19.6277 13.3224 19.3827 13.4239C19.1989 13.5 18.9659 13.5 18.5 13.5H14.5C14.0341 13.5 13.8011 13.5 13.6173 13.4239C13.3723 13.3224 13.1776 13.1277 13.0761 12.8827C13 12.6989 13 12.4659 13 12Z"
        stroke={props.stroke ? props.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{" "}
      <path
        d="M13 18C13 17.5341 13 17.3011 13.0761 17.1173C13.1776 16.8723 13.3723 16.6776 13.6173 16.5761C13.8011 16.5 14.0341 16.5 14.5 16.5H18.5C18.9659 16.5 19.1989 16.5 19.3827 16.5761C19.6277 16.6776 19.8224 16.8723 19.9239 17.1173C20 17.3011 20 17.5341 20 18C20 18.4659 20 18.6989 19.9239 18.8827C19.8224 19.1277 19.6277 19.3224 19.3827 19.4239C19.1989 19.5 18.9659 19.5 18.5 19.5H14.5C14.0341 19.5 13.8011 19.5 13.6173 19.4239C13.3723 19.3224 13.1776 19.1277 13.0761 18.8827C13 18.6989 13 18.4659 13 18Z"
        stroke={props.stroke ? props.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{" "}
      <path
        d="M4 15.1C4 14.5399 4 14.2599 4.10899 14.046C4.20487 13.8578 4.35785 13.7049 4.54601 13.609C4.75992 13.5 5.03995 13.5 5.6 13.5H8.4C8.96005 13.5 9.24008 13.5 9.45399 13.609C9.64215 13.7049 9.79513 13.8578 9.89101 14.046C10 14.2599 10 14.5399 10 15.1V17.9C10 18.4601 10 18.7401 9.89101 18.954C9.79513 19.1422 9.64215 19.2951 9.45399 19.391C9.24008 19.5 8.96005 19.5 8.4 19.5H5.6C5.03995 19.5 4.75992 19.5 4.54601 19.391C4.35785 19.2951 4.20487 19.1422 4.10899 18.954C4 18.7401 4 18.4601 4 17.9V15.1Z"
        stroke={props.stroke ? props.stroke : "#000000"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export default LayoutIcon;
